@if (this.score(); as score) {
  @if (score !== NO_VALUE_FOR_SCORE) {
    <span>{{ score }}</span>
  } @else {
    <glxy-blank-value></glxy-blank-value>
  }
} @else {
  <div class="stencil-shimmer"></div>
}
